import { useTranslation } from "pro-features/components/WithTranslation";

import { AllCompetitorsModal } from "../components/AllCompetitorsModal";
import { AllCompetitorsModalProvider } from "../components/AllCompetitorsModalContext";
import { WidgetCard } from "../WidgetCard";

import { ShareOfWebsiteTraffic, ShareOfWebsiteTrafficCompetitorsTable } from "./components";

export const ShareOfWebsiteTrafficContainer = () => {
    const translate = useTranslation();

    const actions = (
        <AllCompetitorsModal>
            <ShareOfWebsiteTrafficCompetitorsTable />
        </AllCompetitorsModal>
    );

    return (
        <AllCompetitorsModalProvider>
            <WidgetCard
                subtitle={translate("bt.report.channels.share-of-website-traffic-table.subtitle")}
                title={translate("bt.report.channels.share-of-website-traffic-table.title")}
                automationIds={{
                    title: "share-of-website-traffic-title",
                    body: "share-of-website-traffic-body",
                }}
                actions={actions}
            >
                <ShareOfWebsiteTraffic />
            </WidgetCard>
        </AllCompetitorsModalProvider>
    );
};
